import { render, staticRenderFns } from "./SettingsHotel.vue?vue&type=template&id=c7968d5c&scoped=true"
import script from "./SettingsHotel.vue?vue&type=script&lang=js"
export * from "./SettingsHotel.vue?vue&type=script&lang=js"
import style0 from "./SettingsHotel.vue?vue&type=style&index=0&id=c7968d5c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7968d5c",
  null
  
)

export default component.exports